function Template_form_plugin_container(element) {
    this.$element = $(element);
    
    this.selectors = {
	    fieldTemplateId: '.js-field-template-id',
	    selectTemplateId: '#filter_template_id'
    };
    
    this.init = function() {	    
	    this.$fieldTemplateId = this.$element.find(this.selectors.fieldTemplateId);
	    this.$selectTemplateId = $(this.selectors.selectTemplateId);	    
	   	    
    	this.$fieldTemplateId.val(this.$selectTemplateId.val());
    };
}
